import React from 'react';
import Button from '../../Button/Button';
import './GetStartedSection.scss';
// const linkCards = [
//   {
//     id: 1,
//     title: 'See how it works',
//     description: 'Learn about how Vymo works for you',
//     link: '/why-vymo',
//   },
//   {
//     id: 2,
//     title: 'Get Pricing',
//     description: 'Get in touch with our team and get a quote',
//     link: '/request-a-demo',
//   },
//   // {
//   //   id: 3,
//   //   title: 'Get started',
//   //   description: 'Start using Vymo for enterprise and grow revenue',
//   //   link: '#!',
//   // },
  
// ];
function GetStartedSection() {
  return (
    <section className="bg-darkblack get-started-section -mb-[1px] md:mb-0">
      <div className="container md:p-2">
        <div className="flex flex-wrap link-card-container">
            <div className="flex w-full md:w-8/12 order-last md:order-first black-box justify-start items-center">
              
              {/* {linkCards.map((lc) => (
                <div className="link-col" key={lc.id}>
                  <a
                    className="pt-4 pr-2 pb-2 pl-4 relative flex-1 flex justify-between flex-row link-card"
                    href={lc.link}>
                    <div>
                      <h3 className="text-20 text-white font-bold leading-7 tracking-normal font-secondary">
                        {lc.title}
                      </h3>
                      <p className="text-14 md:text-16 text-white opacity-60 leading-[21px] md:leading-6 mt-0 md:mt-1 pr-6 font-secondary">
                        {lc.description}
                      </p>
                    </div>
                    <img
                      src="/img/icons/link-arrow.svg"
                      className="-mt-2 self-start"
                      height="34px"
                      width="34px"
                      alt="arrow icon"
                    />
                  </a>
                </div>
              ))} */}

              <h3 className="text-center md:text-left text-white font-secondary text-18 font-medium leading-6 mt-3 md:mt-0 tracking-normal">Ready to get started?</h3>
              <a href="/us/request-demo">
                <Button className="md:ml-[40px] red-btn">Book a Demo</Button>
              </a>

            </div>
            <div className="flex w-full md:w-4/12 p-0 pl-2 justify-center md:mt-0 mt-0 order-first md:order-last gap-2 items-normal">
                {/* <img src="/img/users-love-us.svg"  width="96px" alt='user love us award' className='pr-[14px]' loading="lazy"/> */}
                <a href="#!" title="SOC 2 Type II">
                  <img src="/img/soc-2-type-ii-logo.png"  alt='SOC 2 Type II' className='pr-[18px] w-[112px] h-auto md:h-[95px] mt-2.5' loading="lazy"/>
                </a>
                {/* <a href="https://www.g2.com/products/vymo/reviews/start?return_to=https%3A%2F%2Fwww.g2.com%2Fproducts%2Fvymo%2Ftake_survey" target="_blank" title="G2 Leader Winter 2024">
                  <img src="/img/Leader_Winter_2024.png" alt='Leader Winter 2024 award' className='pr-[18px] w-[100px] h-auto md:h-[110px] mt-4.5' loading="lazy"/>
                </a> */}
                <div className="flex flex-col gap-[12px] justify-center items-center mt-2">
                    <a href="https://play.google.com/store/apps/details?id=com.getvymo.android&pcampaignid=web_share" target="_blank">
                      <img src="/img/google-play@2x.webp" className="w-[108px]" alt="play store icon"/>
                    </a>
                </div>
                <div className="flex flex-col gap-[12px] justify-center items-center mt-2">
                    <a href="https://apps.apple.com/in/app/vymo/id1066605286" target="_blank">
                      <img src="/img/app-store@2x.webp" className="w-[108px]" alt="apple app store icon"/>
                    </a>

                </div>
            </div>
        </div>
      </div>
    </section>
  );
}

export default GetStartedSection;
